
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/xml-formatter",
      function () {
        return require("private-next-pages/xml-formatter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/xml-formatter"])
      });
    }
  